import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { ServerSetting } from '../Models/ServerSetting';

class SettingsApi {
  static getServerSetting(settingName: string) {
    return axios.get<ServerSetting>(
      `${API_URL}/api/settings/${settingName}`,
      getAuthHeader()
    );
  }
  static getServerSettingsList() {
    return axios.get<ServerSetting[]>(
      `${API_URL}/api/settings/list`,
      getAuthHeader()
    );
  }
  static updateServerSetting(request: ServerSetting) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/settings`,
      request,
      getAuthHeader()
    );
  }
}

export default SettingsApi;
